enum RiskBandEnum {
    BandOne = 'BAND_ONE',
    BandTwo = 'BAND_TWO',
    BandThree = 'BAND_THREE',
    BandZero = 'BAND_ZERO',
}

export default RiskBandEnum;
